export default __webpack_public_path__ + "static/media/num-7.62c7990a.svg";